import React from 'react';

export default function WscToggleSwitch({ checked, onChange, isDark }) {
  return (
    <div
      onClick={() => onChange && onChange(!checked)}
      style={{
        width: 28, height: 16, borderRadius: 8, cursor: 'pointer',
        background: checked ? '#4ADE80' : 'rgba(255,255,255,0.10)',
        position: 'relative', transition: 'background 0.15s ease',
        flexShrink: 0,
      }}
    >
      <div style={{
        width: 12, height: 12, borderRadius: '50%',
        background: '#fff',
        position: 'absolute', top: 2,
        left: checked ? 14 : 2,
        transition: 'left 0.15s ease',
        boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
      }} />
    </div>
  );
}
